module.exports = __webpack_public_path__ + "static/404@3x-44185711901e95cb41e1da42a70bf88c.png";